function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  d: "M24.575 14.0467C24.1831 12.0607 23.1139 10.2723 21.5499 8.98712C19.9859 7.70191 18.0243 6.99954 16 7C12.6283 7 9.7 8.91333 8.24167 11.7133C6.52694 11.8986 4.94117 12.7111 3.78907 13.9945C2.63697 15.278 1.9998 16.942 2 18.6667C2 22.5283 5.13833 25.6667 9 25.6667H24.1667C27.3867 25.6667 30 23.0533 30 19.8333C30 16.7533 27.6083 14.2567 24.575 14.0467ZM18.3333 17.5V22.1667H13.6667V17.5H10.1667L15.5917 12.075C15.825 11.8417 16.1867 11.8417 16.42 12.075L21.8333 17.5H18.3333Z"
});

function SvgFilepicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilepicker);
export default __webpack_public_path__ + "static/media/filepicker.476722c7.svg";
export { ForwardRef as ReactComponent };